<template>
  <div class="ti-notification">
    <wb-notification
      :icon="notification.icon ? notification.icon : 'warning'"
      :lifetime="notification.lifetime ? notification.lifetime : 30000"
      :theme="notification.theme ? notification.theme : 'dark'"
      :mode="notification.mode ? notification.mode : 'error'"
      :hide-dismiss-button="notification.hideDismissButton"
      @wbdismiss="closeNotification"
      @wbexpire="closeNotification"
    >
      <wb-notification-content>
        {{ $t(notification.message || '') }}
      </wb-notification-content>
    </wb-notification>
  </div>
</template>
<script lang="ts" setup>
import { Notification } from '@tradein/store';
import { watch } from 'vue';
import { trackingService } from '../../utils/tracking';

interface Props {
  notification: Notification;
  currentStepId: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['closeNotification']);

watch(
  () => props.notification,
  () => {
    trackingService.publishClick(
      'form',
      `${props.currentStepId}.form_error`,
      undefined,
      [`${props.notification?.message}`],
    );
  },
);

const closeNotification = (): void => {
  emit('closeNotification');
};
</script>
<style lang="scss">
.ti-notification {
  position: relative;
  padding: var(--wb-spacing-s) 0 calc(var(--wb-spacing-l) - var(--wb-spacing-m))
    0;
  width: 100%;
}
</style>
